import { Array, Boolean, Null, Number, Optional, Record, String } from 'runtypes';

export const DestinationCopyAccountRunType = Record({
	description: String,
	id: Number,
});

export const MailDetailExtrasRunType = Record({
	answered: Boolean,
	answeredBy: String,
	answeredWithTheMailId: Null.Or(String),
	containsExternalImages: Boolean,
	isDeleted: Boolean,
	isSpam: Boolean,
	shouldShowTheClaimButton: Boolean,
	shouldShowTheReplyButton: Boolean,
	smtpLogLog: Null.Or(String),
	smtpLogType: Null.Or(String),
	userHasAccessToTheAnswer: Boolean,
	userIsAuthorizedToDelete: Boolean,
	userIsAuthorizedToSpam: Boolean,
});

export const MailExtrasRunType = Record({
	answered: Boolean,
	answeredBy: String,
	answeredWithTheMailId: Null.Or(String),
	destinationCopyAccounts: Array(DestinationCopyAccountRunType),
	forwarded: Boolean,
	forwardedBy: String,
	hasAttachments: Boolean,
	isDeleted: Boolean,
	isSpam: Boolean,
	isTrash: Boolean,
	shouldShowTheClaimButton: Boolean,
	shouldShowTheReplyButton: Boolean,
	smtpLogDescription: Optional(String),
	smtpLogType: Optional(String),
	userIsAuthorizedToDelete: Boolean,
	userIsAuthorizedToSpam: Boolean,
});
